import { render, staticRenderFns } from "./InvoiceNumbering.yaml?vue&type=template&id=40865824&component"
import script from "./InvoiceNumbering.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceNumbering.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports